module.exports = __webpack_public_path__ + "static/pattern-style-1-e2040d0914d698df6b5fac13efd30db7.png";